export default function () {
    let storedPaymentOption = sessionStorage?.getItem('checkout_payment_option');

    if (!storedPaymentOption) {
        return null;
    }

    return JSON.parse(storedPaymentOption);
}
